<template>
  <div id="footer_menu1"  class="hoc clear" style="width: 100%; background: #03a9f48c; margin-top: 10px;">
    <footer class="row_footer1">
      <div class="col_footer1_menu w-25">
        <div class="d-flex justify-center">
          <a
            href="https://play.google.com/store/apps/details?id=com.qr.vcard"
            target="_blank"
            style="text-align: left"
          >
            <img
              style="border-radius: 5px"
              src="/img/footer/qr-tai-VCard.png"
            />
          </a>
          <div
            class="d-flex flex-column justify-space-around"
            style="margin-left: 10px"
          >
            <img
              class="imgqr"
              style="width: 50px; margin: auto"
              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1695703991574rQw2F"
            />

            <a
              href="https://apps.apple.com/vn/app/vcards/id1565903620?l=vi"
              target="_blank"
              style="text-align: left"
            >
              <img
                class="imgqr"
                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=16957034549947vdJF"
              />
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.qr.vcard"
              target="_blank"
              style="text-align: left; margin-top: 10px"
            >
              <img
                class="imgqr"
                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1695703486057vHWBF"
              />
            </a>
          </div>
        </div>
      </div>

      <div class="col_footer1_menu w-25">
        <div class="item-menu item-menu--style">
          <a
            class="m-auto h-58p"
            target="_blank"
            href="https://www.sbv.gov.vn/webcenter/portal/vi/menu/trangchu/ttsk/ttsk_chitiet?centerWidth=80%25&amp;dDocName=SBV331391&amp;leftWidth=20%25&amp;rightWidth=0%25&amp;showFooter=false&amp;showHeader=false&amp;_adf.ctrl-state=m6wjtbt77_120&amp;_afrLoop=7768180623512000#%40%3F_afrLoop%3D7768180623512000%26centerWidth%3D80%2525%26dDocName%3DSBV331391%26leftWidth%3D20%2525%26rightWidth%3D0%2525%26showFooter%3Dfalse%26showHeader%3Dfalse%26_adf.ctrl-state%3Du3lob0i2z_4"
          >
            <img
              src="/img/footer/NHNN_trans.png"
              style="width: 87px; height: 51px"
            />
          </a>

          <a
            target="_blank"
            href="https://www.sbv.gov.vn/webcenter/portal/vi/menu/trangchu/ttsk/ttsk_chitiet?centerWidth=80%25&amp;dDocName=SBV331391&amp;leftWidth=20%25&amp;rightWidth=0%25&amp;showFooter=false&amp;showHeader=false&amp;_adf.ctrl-state=m6wjtbt77_120&amp;_afrLoop=7768180623512000#%40%3F_afrLoop%3D7768180623512000%26centerWidth%3D80%2525%26dDocName%3DSBV331391%26leftWidth%3D20%2525%26rightWidth%3D0%2525%26showFooter%3Dfalse%26showHeader%3Dfalse%26_adf.ctrl-state%3Du3lob0i2z_4"
          >
          {{ 
           currentLanguage.footer_text_row_footer1_nganHang }} 
           <br>
            {{ 
           currentLanguage.footer_text_row_footer1_giayPhep
          }}
          </a>
        </div>
      </div>
      <div class="col_footer1_menu w-25">
        <div class="item-menu item-menu--style">
          <a
            id="bocongthuong"
            href="https://vimass.vn/vmbank/services/media/viewFile?id=21_10_5_Giay_phep_kinh_doanh_san_pham_dich_vu_MMDS.pdf"
            target="_blank"
            class="m-auto"
          >
            <img
              class="m-r-168p"
              src="/img/footer/Bieu_Trung_BCY.png"
              style="width: 55px; height: 58px"
            />
          </a>
          <div class="w-100 text-style">
            <a
              class="w-100 text-left p-right"
              href="https://vimass.vn/vmbank/services/media/viewFile?id=21_10_5_Giay_phep_kinh_doanh_san_pham_dich_vu_MMDS.pdf"
              target="_blank"
              > {{ currentLanguage.footer_text_row_footer1_giayPhepKinhDoanh }}</a
            >
          </div>
          <div class="w-100 text-style">
            <a
              class="w-100 text-left"
              href="https://drive.google.com/file/d/1ch2fOQ3ayG5Hi07-NoncehexSMEExAzk/view?usp=sharing"
              target="_blank"
            >
            {{ currentLanguage.footer_text_row_footer1_giayPhepXuatNhapKhau }}
             </a
            >
          </div>
        </div>
      </div>

      <div class="col_footer1_menu w-25">
        <div class="w-100 text-style">
          <a
            id="bocongthuong"
            href="http://online.gov.vn/Home/WebDetails/65124"
            target="_blank"
          >
            <img
              style="padding-left: 10px; width: 128px; margin-bottom: 12px"
              src="/img/footer/bct.png"
            />
          </a>
        </div>
        <div class="w-100 text-style">
          <a class="me-10p" href="https://qrvn.vn/" target="_blank"
            >{{currentLanguage.footer_text_row_footer1_xemThem}}https://qrvn.vn</a
          >
        </div>
        <div class="w-100 text-style">
          <a class="me-10p" href="https://vimass.vn/vidientu" target="_blank"
            >{{currentLanguage.footer_text_row_footer1_xemThem}}
            https:/vimass.vn/vidientu</a
          >
        </div>
      </div>
    </footer>

    <footer
      id="footer"
      class="hoc clear"
      style="background: #007abe; float: none"
    >
      <!-- ################################################################################################ -->
      <div class="container-footer">
        <div class="footer-bolck footer-bolck--0">
          <div class="footer-bolck__item">
            <span href="/"
              ><strong>{{currentLanguage.footer_text_tenCty}}</strong>
              <img
                src="img/footer/logovimass.png"
                style="width: 62px; vertical-align: inherit"
            /></span>
          </div>
          <div class="footer-bolck__item">
            <span>{{currentLanguage.footer_text_hoiSoHaNoi}}</span>
          </div>
          <div class="footer-bolck__item">
            <span>{{currentLanguage.footer_text_cnHCM}}</span>
          </div>
          <div class="footer-bolck__item">
            <span>{{currentLanguage.footer_text_cnDN}}</span>
          </div>

          <div class="footer-bolck__item">
            <span>{{currentLanguage.footer_text_cnCT}}</span>
          </div>
          <div class="footer-bolck__item">
            <span>{{currentLanguage.footer_text_cnHP}}</span>
          </div>
        </div>
        <div class="footer-bolck footer-bolck--1">
          <div class="footer-bolck__item">
            <span>{{currentLanguage.footer_text_cnHue}}</span>
          </div>
          <div class="footer-bolck__item">
            <span>{{currentLanguage.footer_text_cnNA}}</span>
          </div>
          <div class="footer-bolck__item">
            <span>{{currentLanguage.footer_text_cnTH}}</span>
          </div>

          <div class="footer-bolck__item">
            <span>{{currentLanguage.footer_text_cnBDinh}}</span>
          </div>

          <div class="footer-bolck__item">
            <a href="https://qrvn.vn/" target="_blank"
              ><strong>{{currentLanguage.footer_text_ctyTrucThuoc}} -</strong>
              <img
                src="https://web.vimass.vn/vmbank/services/media/getImage?id=logoqrvnnew.png"
                style="height: 17px; vertical-align: inherit"
              />
            </a>
          </div>

          <!-- <div class="footer-bolck__item">
            <a href="https://vtaxi.com.vn/" target="_blank"
              ><strong>{{currentLanguage.footer_text_ctyTrucThuoc}} -</strong>
              <img
                src="images/img-item-vimass-2022/Logo_Vtaxi_white.svg"
                style="height: 17px; vertical-align: inherit"
              />
            </a>
          </div> -->
        </div>
        <div class="footer-bolck footer-bolck--2">
          <div class="footer-bolck__item">
            <a
              id="urlFooterChuongTrinhTaiTro"
              href="/giaiphapchuyendoiso"
              target="_blank"
            >
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{currentLanguage.footer_text_giaiPhapChuyenDoiSo}} 
             </a
            >
          </div>

          <div class="footer-bolck__item">
            <a id="urlFooterUngDung" href="/chuongtrinhthidiemvataitro" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i
              > {{currentLanguage.header_text_theDaNang_CTThiDiem  }} & {{ currentLanguage.header_text_theDaNang_CTTaiCho }}</a
            >
          </div>

          <div class="footer-bolck__item">
            <a id="urlFooterTheDaNang" href="/giaoduc" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{currentLanguage.header_text_theDaNang_phoCap_bogiaoduc}} 

              </a
            >
          </div>
          <div class="footer-bolck__item">
            <a id="urlFooterTheDaNang" href="/y-te" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{currentLanguage.header_text_theDaNang_phoCap_yte}} 

              </a
            >
          </div>

          <div class="footer-bolck__item">
            <a
              id="urlFooterDiemThanhToan"
              href="/giaothongvadichvucong"
              target="_blank"
            >
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{currentLanguage.header_text_diemThanhToan_diChuyen}} &
              {{currentLanguage.header_text_dichVuCong}} 
              </a
            >
          </div>

          <div class="footer-bolck__item">
            <a id="urlFooterDiemRaVao" href="/diemthanhtoanvadinhdanh" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{currentLanguage.footer_text_diemThanhToan}} &
              {{currentLanguage.footer_text_diemRaVao}} </a
            >
          </div>

          <div class="footer-bolck__item">
            <a id="urlFooterThietBi" href="/thietbivadichvu" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
          {{currentLanguage.footer_text_thietBi}} &{{ currentLanguage.footer_text_dichVu }} 
              </a
            >
          </div>


          <div class="footer-bolck__item">
            <a id="urlFooterCongTy" href="/congty" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{currentLanguage.footer_text_cty}} </a
            >
          </div>
        </div>
      </div>
      <!-- ################################################################################################ -->
    </footer>
  </div>
</template>
<script>
import {languages} from "@/components/languages"

export default {
 
  data() {
    return {
      currentLanguage: languages.vi,
    };
  },
  created() {
  const savedLanguage = localStorage.getItem("languages");
  if (savedLanguage && languages[savedLanguage]) {
    this.currentLanguage = languages[savedLanguage];
  }
},
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
    },
  },
};
</script>
